import getSearchQueryPartAtPosition from './getSearchQueryPartAtPosition'

export default function positionAfterAmendSearchQueryString(
  baseQueryString,
  amendString,
  position = baseQueryString.length,
  commit = true
) {
  const currentPart = getSearchQueryPartAtPosition(baseQueryString, position)
  const { before = '' } = currentPart || {}
  const finalSpace = !amendString.match(/:$/) && commit ? 1 : 0
  return `${before}${before && ' '}${amendString}`.length + finalSpace
}
